<template>
  <div :id="this._uid" style="display: none">
    <div>
      <slot @click="$emit('click')"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
  import GoogleMapChildren from './GoogleMapChildren'

  export default {
    name: 'GoogleMapMarker',
    extends: GoogleMapChildren,
    data() {
      return {
        info_item: null,
      }
    },

    beforeDestroy() {
      if (this.info_item) {
        this.info_item.close()
      }
    },
    methods: {
      init: function () {
        if (this.item == null) {
          var self = this
          this.item = new google.maps.Marker({
            position: new google.maps.LatLng(self.position.lat, self.position.lng),
            label: self.label,
            title: self.title,
            clickable: this.clickable,
            map: this.$parent.getMap(),
            animation: google.maps.Animation.DROP,
            // Set the icon only if prop is set
            icon: self.icon ? {
              url: self.icon,
              // This marker is 20 pixels wide by 32 pixels high.
              scaledSize: new google.maps.Size(this.iconSize.width, this.iconSize.height), // scaled size
              // The origin for this image is (0, 0).
              origin: new google.maps.Point(this.iconOrigin[0], this.iconOrigin[1]),
              // The anchor for this image is the base of the flagpole at (0, 32).
              anchor: new google.maps.Point(this.iconAnchor[0], this.iconAnchor[1]), // using dimention / 2 we can center the images
              labelOrigin: new google.maps.Point(this.labelOrigin[0], this.labelOrigin[1]),
            } : null
          })

          if (this.clickable !== false) {
            this.item.addListener('click', function (marker) {
              self.$emit('click', marker)
            })
          }

          if (this.forceInfo || typeof this.$slots.default != 'undefined') {
            this.info_item = new google.maps.InfoWindow({
              content: document.getElementById(self._uid).firstChild,
            })

            this.item.addListener('click', function (marker) {
              self.info_item.open(self.$parent.getMap(), self.item)
            })
          }
        }
      },
    },
    props: {
      forceInfo: {
        type: Boolean,
        default: false,
      },
      position: {
        type: Object,
        required: true,
      },
      // On mouse hover
      title: {
        type: String,
        required: true,
      },
      // Wrote on marker
      label: {
        type: String,
        required: true,
      },
      labelOrigin: {
        type: Array,
        default: function () {
          return [15, 15]
        }
      },
      // Url of icon
      icon: {
        type: String,
        default: null,
      },
      iconSize: {
        type: Object,
        default: function () {
          return {width: 30, height: 30}
        }
      },
      iconOrigin: {
        type: Array,
        default: function () {
          return [0, 0]
        }
      },
      iconAnchor: {
        type: Array,
        default: function () {
          return [15, 15]
        }
      },
      clickable: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      position: {
        handler: function () {
          if (this.item) {
            this.item.setPosition(new google.maps.LatLng(this.position.lat, this.position.lng))
          }
        },
        deep: true
      },
      icon: function (val) {
        this.item.setIcon({
          url: val,
          // This marker is 20 pixels wide by 32 pixels high.
          scaledSize: new google.maps.Size(this.iconSize.width, this.iconSize.height), // scaled size
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          anchor: new google.maps.Point(15, 15), // using dimention / 2 we can center the images
        })
      },
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// GoogleMapMarker.vue?3c26cce0